import React from "react";

export function CpFloatingMenuDivider() {
  return <div className="cp-divider" />;
}
